import { StyleSheet } from 'aphrodite';
import { charmGray, titles, white } from '../../styles/colors';

const slideInFromTopNFadeNZoom = {
	'0%': {
		transform: 'translateY(-8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: 'translateY(0) scale(1)',
		opacity: 1,
	},
};
const slideInFromBottomNFadeNZoom = {
	'0%': {
		transform: 'translateY(8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: 'translateY(0) scale(1)',
		opacity: 1,
	},
};
const slideInFromLeftNFadeNZoom = {
	'0%': {
		transform: 'translateX(-8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: 'translateX(0) scale(1)',
		opacity: 1,
	},
};
const slideInFromRightNFadeNZoom = {
	'0%': {
		transform: 'translateX(8px) scale(0.95)',
		opacity: 0,
	},
	'100%': {
		transform: 'translateX(0) scale(1)',
		opacity: 1,
	},
};

const fadeOutZoomOut = {
	'0%': {
		transform: 'scale(1)',
		opacity: 1,
	},
	'100%': {
		transform: 'scale(0.95)',
		opacity: 0,
	},
};

export const s = StyleSheet.create({
	content: {
		zIndex: 50,
		overflow: 'hidden',
		borderRadius: 8,
		backgroundColor: white,
		boxSizing: `border-box`,
		padding: `8px 16px`,
		color: titles,
		fontSize: `0.75rem`,
		border: `1px solid ${charmGray}`,
		animationDuration: '150ms',
		animationTimingFunction: `cubic-bezier(0.4, 0, 0.2, 1)`,
		':is([data-state="closed"])': {
			animationName: [fadeOutZoomOut],
		},
		':is([data-side="bottom"][data-state="open"])': {
			animationName: slideInFromTopNFadeNZoom,
		},
		':is([data-side="top"][data-state="open"])': {
			animationName: slideInFromBottomNFadeNZoom,
		},
		':is([data-side="left"][data-state="open"])': {
			animationName: slideInFromRightNFadeNZoom,
		},
		':is([data-side="right"][data-state="open"])': {
			animationName: slideInFromLeftNFadeNZoom,
		},
	},
	contentWithMaxWidth: {
		maxWidth: '300px',
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		hyphens: 'auto',
	},
});
